import Backbone from 'backbone'
import AlertSubscriptions from 'scoreboard/admin/alerts/alert-subscriptions'
import template from './alert-subscriptions-editor.hbs'
import i18n from 'scoreboard/components/i18n'
import AlertHelper from 'scoreboard/alerts/alert-helper'
import _ from 'lodash'

const AlertSubscriptionsEditor = Backbone.View.extend({

	className: 'alert-subscriptions-editor',

	events: {
		'click .close': 'close'
	},

	initialize: function(opts={}) {
		this.opts = opts
		this.data = this.opts.data
	},

	render: function() {
		this.$el.empty().append(template(this.context()))
		this.alertSubscriptions = new AlertSubscriptions({ data: this.data })
		this.$('.dialog-body-content').append(this.alertSubscriptions.el)
		this.alertSubscriptions.on('update-subscription', this.updateData.bind(this))
		this.alertSubscriptions.render()
	},

	context: function() {
		return {
			heading: i18n.get('home.alerts.alertTriggers', i18n.get('common.edit'))
		}
	},

	/**
	 * The subscription list can be closed and reopened without requesting data
	 * from the server, so if new domain items/organizations are added, that has
	 * to be maintained on the client. This updates the current data with a new
	 * alert subscription.
	 */
	updateData: function(data) {
		const {subscription, organization, domainItem} = data

		const addItem = (item, domainType) => {
			const dataProperty = AlertHelper.metadataPropertyByDomainType[domainType]

			if (_.isNil(this.data[dataProperty])) this.data[dataProperty] = []
			const collection = this.data[dataProperty]
			if (!_.some(collection, i => i.id == item.id)) {
				collection.push(item)
			}
		}

		// organization won't be set by default but is necessary
		domainItem.organizationId = organization.id

		addItem(domainItem, subscription.domainType)
		addItem(organization, 'organizations')
	},

	close: function() {
		this.trigger('done', _.map(this.alertSubscriptions.subs, 'subscription'))
	},

	autoRemove: true
})

export default AlertSubscriptionsEditor
AlertSubscriptionsEditor.__filename__ = 'home/alerts/alert-subscriptions-editor.js'
